export default defineNuxtPlugin({
  name: "down-redirect",
  dependsOn: ["launchdarkly"],
  setup() {
    const enableStatusPage = useBooleanFeatureFlag("ops_enable_status_page");
    const route = useRoute();
    watchEffect(() => {
      if (enableStatusPage.value && route.path !== "/down") {
        navigateTo("/down");
      }
    });
  },
});
